import React, { useContext, useEffect, useState } from 'react';
import { UNSAFE_DataRouterContext, useBlocker } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { Confirm } from '../settings/shared';
function Guard({ state, t }) {
  const blocker = useBlocker(
    () => !state.current.released && (state.current.dirty || state.current.busy),
  );
  const [notice, setNotice] = useState(false),
    id = React.useId();
  useEffect(() => {
    if (blocker.state === 'blocked' && state.current.busy) {
      setNotice(true);
      blocker.reset();
    }
  }, [blocker, state]);
  if (notice)
    return (
      <Dialog
        open
        onClose={() => setNotice(false)}
        className="pp-review-dialog"
        aria-labelledby={id}
      >
        <DialogTitle id={id}>{t('editor.busyTitle')}</DialogTitle>
        <DialogContent>
          <p>{t('editor.busyBody')}</p>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => setNotice(false)}>
            {t('common.confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  return blocker.state === 'blocked' && !state.current.busy ? (
    <Confirm
      title={t('editor.discardTitle')}
      body={t('editor.discardBody')}
      cancel={t('editor.keepWriting')}
      confirm={t('editor.discard')}
      onCancel={() => blocker.reset()}
      onConfirm={() => {
        if (state.current.busy) {
          setNotice(true);
          blocker.reset();
          return;
        }
        state.current.released = true;
        blocker.proceed();
      }}
    />
  ) : null;
}
export default function ContactDraftGuard({ state, t }) {
  const router = useContext(UNSAFE_DataRouterContext);
  useEffect(() => {
    const handler = (e) => {
      if (!state.current.released && (state.current.dirty || state.current.busy)) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [state]);
  return router ? <Guard state={state} t={t} /> : null;
}
